import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { showHideWaitingAreaAddUsersModal } from 'actions/modal.js';
import { clearSearchUserForm } from 'actions/user.js';
import { previousPage } from 'actions/navigationBar';
import EmailUsersButton from '../../../shared/email-users-button/content';

export default function RightPanelOrTopPanel(props) {
  const dispatch = useDispatch();
  const [extendContent, setExtendContent] = useState(false);

  useEffect(() => {
    var clipboard = new window.Clipboard('.copy-to-clipboard-email-all-users');
    clipboard.on('success', function (e) {
      console.info('Action:', e.action);
      console.info('Text:', e.text);
      console.info('Trigger:', e.trigger);
      e.clearSelection();
    });
  }, []);

  const openAddUserModal = () => {
    if (!areWaitingAreaUsersLoaded()) return;
    console.log('openAddUser Modal clicked');
    dispatch(clearSearchUserForm());
    dispatch(showHideWaitingAreaAddUsersModal(true));
  };

  const areWaitingAreaUsersLoaded = () => {
    return !props.fetchingUserICanManage && props.usersIcanManage;
  };

  const areWaitingAreaUsersAvailable = () => {
    return areWaitingAreaUsersLoaded() && props.usersIcanManage.length > 0;
  };

  const isWaitingAreaLoaded = props.waitingArea && props.waitingArea.id > 0;
  const userEmails = props.usersIcanManage.map((user) => user.email);

  const buttonsForDesktop = (
    <div>
      <button
        type="button"
        className={`ui labeled icon button mrbs color-button color-white right-hand-side-button ${
          !areWaitingAreaUsersLoaded() ? 'disable' : ''
        }`}
        onClick={openAddUserModal}
      >
        <i className="plus icon" />
        {APP.LANGUAGE.WaitingAreaManageUsers.AddUserButtonText}
      </button>

      <EmailUsersButton
        userEmails={userEmails}
        dispatch={dispatch}
        isUsersAvailable={areWaitingAreaUsersAvailable()}
        entityName={props.waitingArea.name}
        areUsersLoaded={areWaitingAreaUsersLoaded()}
        isDesktop={true}
        handleOpen={() => {
          setExtendContent(true);
        }}
        handleClose={() => {
          setExtendContent(false);
        }}
      />
    </div>
  );

  const buttonsForTablet = (
    <div>
      <button
        className={`ui labeled icon button color-button color-white right-hand-side-button mrrsss mrbxxs ${
          !areWaitingAreaUsersLoaded() ? 'disable' : ''
        }`}
        onClick={openAddUserModal}
      >
        <i
          className="plus icon"
          ref={(el) => {
            if (el) {
              el.style.setProperty('font-size', '1em', 'important');
            }
          }}
        />
        {APP.LANGUAGE.WaitingAreaManageUsers.AddUserButtonText}
      </button>

      <EmailUsersButton
        userEmails={userEmails}
        dispatch={dispatch}
        isUsersAvailable={areWaitingAreaUsersAvailable()}
        entityName={props.waitingArea.name}
        areUsersLoaded={areWaitingAreaUsersLoaded()}
        isTab={true}
        handleOpen={() => {
          setExtendContent(true);
        }}
        handleClose={() => {
          setExtendContent(false);
        }}
      />
    </div>
  );

  const buttonsForMobile = (
    <div>
      <button
        className={`ui icon button color-button color-white mrrsss mrbm ${
          !areWaitingAreaUsersLoaded() ? 'disable' : ''
        }`}
        onClick={openAddUserModal}
      >
        <i className="plus icon" />
      </button>

      <EmailUsersButton
        userEmails={userEmails}
        dispatch={dispatch}
        isUsersAvailable={areWaitingAreaUsersAvailable()}
        entityName={props.waitingArea.name}
        areUsersLoaded={areWaitingAreaUsersLoaded()}
        isMobile={true}
        handleOpen={() => {
          setExtendContent(true);
        }}
        handleClose={() => {
          setExtendContent(false);
        }}
      />
    </div>
  );
  return (
    <div style={{ height: '100%' }}>
      <Container fluid as={Media} greaterThanOrEqual="computer" style={{ height: '100%' }}>
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdtxl pdbm pdrm logo-on-right-hand">
            <img className="ui image pdtxs umbrella-logo umbrella-logo-large" src={APP.IMAGES.UmbrellaLogo.default} />
            <img className="ui image  umbrella-logo umbrella-logo-small" src={APP.IMAGES.SmallUmbrellaLogo.default} />
          </div>
          <div className="pdbs pdll pdrm">{buttonsForDesktop}</div>
          <div className="pdbm pdrm pdlm">{props.bottomSession}</div>
        </div>
      </Container>
      <Container fluid as={Media} at="tablet">
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdlm pdrm">{buttonsForTablet}</div>
          {isWaitingAreaLoaded && (
            <div className="mrts pdtxs mrbm">
              <Link
                className={
                  (props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? 'back-to-org-link '
                    : 'back-to-wa-link color-waiting-area-text ') + 'left-text pdlm pdbs'
                }
                to={
                  props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? `/organisational-unit/view-all`
                    : `/waiting-area/view-one/${props.waitingArea.id}`
                }
                onClick={() => {
                  dispatch(previousPage(APP.LANGUAGE.WaitingAreaManageUsers.PageHeaderTitle));
                }}
              >
                <i className="chevron circle left icon" />
                <span>
                  {props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText
                    : APP.LANGUAGE.WaitingAreaManageUsers.BackToWaitingAreaLinkText}
                </span>
              </Link>
            </div>
          )}
        </div>
      </Container>
      <Container fluid as={Media} at="mobile">
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdlm pdrm">{buttonsForMobile}</div>
          {isWaitingAreaLoaded && (
            <div className="mrbs">
              <Link
                className={
                  (props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? 'back-to-org-link '
                    : 'back-to-wa-link color-waiting-area-text ') + 'left-text pdlm pdbs'
                }
                to={
                  props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? `/organisational-unit/view-all`
                    : `/waiting-area/view-one/${props.waitingArea.id}`
                }
                onClick={() => {
                  dispatch(previousPage(APP.LANGUAGE.WaitingAreaManageUsers.PageHeaderTitle));
                }}
              >
                <i className="chevron circle left icon" />
                <span>
                  {props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText
                    : APP.LANGUAGE.WaitingAreaManageUsers.BackToWaitingAreaLinkText}
                </span>
              </Link>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
}

RightPanelOrTopPanel.propTypes = {
  waitingArea: PropTypes.object.isRequired,
  availableRoles: PropTypes.array,
  usersIcanManage: PropTypes.array.isRequired,
  fetchingUserICanManage: PropTypes.bool,
  dispatch: PropTypes.func,
};
